/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../feeplans/events/assessed_fee_events';
import '../fees/models';
import '../common/token';
import '../money_transfer/common';
import '../common/gateways';
import '../common/instrument';
import '../../google/protobuf/any';
import '../common/fee';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "ledger": {
        "nested": {
          "LedgerEntryDetail": {
            "fields": {
              "feeGroup": {
                "type": ".squareup.ledger.FeeGroup",
                "id": 1,
                "rule": "optional"
              },
              "taxGroup": {
                "type": ".squareup.ledger.TaxGroup",
                "id": 2,
                "rule": "optional"
              },
              "payment": {
                "type": ".squareup.ledger.PaymentDetail",
                "id": 3,
                "rule": "optional"
              },
              "moneyTransfer": {
                "type": ".squareup.ledger.MoneyTransferDetail",
                "id": 4,
                "rule": "optional"
              },
              "thirdPartyFee": {
                "type": ".squareup.ledger.ThirdPartyFeeDetail",
                "id": 5,
                "rule": "optional"
              },
              "freeProcessingAdjustment": {
                "type": ".squareup.ledger.FreeProcessingAdjustmentDetail",
                "id": 6,
                "rule": "optional"
              },
              "bookkeeperDetail": {
                "type": ".squareup.ledger.BookkeeperDetail",
                "id": 7,
                "rule": "optional"
              },
              "appFeeDetail": {
                "type": ".squareup.ledger.AppFeeDetail",
                "id": 8,
                "rule": "optional"
              },
              "paymentFeeDetail": {
                "type": ".squareup.ledger.PaymentFeeDetail",
                "id": 9,
                "rule": "optional"
              },
              "recoveryEventDetail": {
                "type": ".squareup.ledger.RecoveryEventDetail",
                "id": 10,
                "rule": "optional"
              },
              "undoDetail": {
                "type": ".squareup.ledger.UndoDetail",
                "id": 11,
                "rule": "optional"
              },
              "netZeroOffsetDetail": {
                "type": ".squareup.ledger.NetZeroOffsetDetail",
                "id": 12,
                "rule": "optional"
              },
              "manualTransferDetail": {
                "type": ".squareup.ledger.ManualTransferDetail",
                "id": 14,
                "rule": "optional"
              },
              "assessedFeeDetail": {
                "type": ".squareup.feeplans.events.AssessedFee",
                "id": 15,
                "rule": "optional"
              },
              "deliveryReimbursementDetail": {
                "type": ".squareup.ledger.DeliveryReimbursementDetail",
                "id": 16,
                "rule": "optional"
              },
              "moneysweeperDetail": {
                "type": ".squareup.ledger.MoneysweeperDetail",
                "id": 17,
                "rule": "optional"
              }
            }
          },
          "UndoDetail": {
            "fields": {
              "originalLedgerEntryType": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RecoveryEventDetail": {
            "fields": {
              "recoveryEventToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "AppFeeDetail": {
            "fields": {
              "paymentMerchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "paymentToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "PaymentFeeDetail": {
            "fields": {
              "principalLedgerEntryToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "squarePaymentFee": {
                "type": ".squareup.fees.PaymentPriceAllocation",
                "id": 2,
                "rule": "repeated"
              },
              "appPaymentFee": {
                "type": ".squareup.fees.PaymentPriceAllocation",
                "id": 3,
                "rule": "repeated"
              },
              "appRefundFee": {
                "type": ".squareup.fees.PaymentPriceAllocation",
                "id": 4,
                "rule": "repeated"
              }
            }
          },
          "FreeProcessingAdjustmentDetail": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "refundUuid": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "relatedEntryType": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "MoneyTransferDetail": {
            "fields": {
              "balanceTenderToken": {
                "type": ".squareup.common.token.TokenPair",
                "id": 2,
                "rule": "optional"
              },
              "reversalDetail": {
                "type": ".squareup.ledger.MoneyTransferDetail.ReversalDetail",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "ReversalDetail": {
                "fields": {
                  "linkedTenderServerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "ThirdPartyFeeDetail": {
            "fields": {
              "thirdPartyFeeAmountDetail": {
                "type": ".squareup.money_transfer.ThirdPartyFeeAmountDetail",
                "id": 4,
                "rule": "optional"
              },
              "thirdPartyAppDetail": {
                "type": ".squareup.ledger.ThirdPartyFeeDetail.ThirdPartyAppDetail",
                "id": 5,
                "rule": "optional"
              },
              "thirdPartyTender": {
                "type": ".squareup.ledger.ThirdPartyFeeDetail.ThirdPartyTender",
                "id": 1
              },
              "thirdPartyReversalTender": {
                "type": ".squareup.ledger.ThirdPartyFeeDetail.ThirdPartyReversalTender",
                "id": 2
              }
            },
            "nested": {
              "ThirdPartyTender": {
                "fields": {
                  "tenderServerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ThirdPartyReversalTender": {
                "fields": {
                  "linkedTenderServerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ThirdPartyAppDetail": {
                "fields": {
                  "connectId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "third_party": {
                "oneof": ["thirdPartyTender", "thirdPartyReversalTender"]
              }
            }
          },
          "PaymentDetail": {
            "fields": {
              "type": {
                "type": ".squareup.ledger.PaymentDetail.Type",
                "id": 1,
                "rule": "optional"
              },
              "refundUuid": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "gatewayName": {
                "type": ".squareup.common.gateways.GatewayName",
                "id": 3,
                "rule": "optional"
              },
              "instrumentType": {
                "type": ".squareup.common.instrument.InstrumentType",
                "id": 4,
                "rule": "optional"
              },
              "captureSource": {
                "type": ".squareup.ledger.PaymentDetail.CaptureSource",
                "id": 5,
                "rule": "optional",
                "options": {
                  "default": "CAPTURE_SOURCE_CARD"
                }
              },
              "readerType": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "CAPTURE": 1,
                  "REFUND": 2
                }
              },
              "CaptureSource": {
                "values": {
                  "DEFAULT_SOURCE_DO_NOT_USE": 0,
                  "CAPTURE_SOURCE_CARD": 1,
                  "CAPTURE_SOURCE_CAPITAL": 2,
                  "CAPTURE_SOURCE_BANK_TRANSFER": 3,
                  "CAPTURE_SOURCE_BANK_TRANSACTION": 4,
                  "CAPTURE_SOURCE_LIGHTNING": 5
                }
              }
            }
          },
          "BookkeeperDetail": {
            "fields": {
              "skipJournaling": {
                "type": "bool",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "inputEvent": {
                "type": ".google.protobuf.Any",
                "id": 5,
                "rule": "optional"
              },
              "paymentBalanceAccountId": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "paymentBalanceTransactionId": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "FeeGroup": {
            "fields": {
              "feeDetail": {
                "type": ".squareup.common.FeeDetail",
                "id": 1,
                "rule": "optional"
              },
              "principalLedgerEntryToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "feeRateDetails": {
                "type": ".squareup.common.FeeDetail",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "TaxGroup": {
            "fields": {
              "taxDetail": {
                "type": ".squareup.common.TaxDetail",
                "id": 1,
                "rule": "repeated"
              },
              "principalLedgerEntryToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "taxLedgerEntryToken": {
                "type": "string",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "NetZeroOffsetDetail": {
            "fields": {
              "type": {
                "type": ".squareup.ledger.NetZeroOffsetDetail.NetZeroOffsetType",
                "id": 1,
                "rule": "optional"
              },
              "netSettledLedgerEntryToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "netSettledLedgerEntryTokens": {
                "type": "string",
                "id": 5,
                "rule": "repeated"
              },
              "pairingOffsetLedgerEntryToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "event": {
                "type": ".squareup.ledger.NetZeroOffsetDetail.NetZeroOffsetEvent",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": "NET_SETTLEMENT"
                }
              }
            },
            "nested": {
              "NetZeroOffsetEvent": {
                "values": {
                  "NET_ZERO_OFFSET_EVENT_TYPE_DO_NOT_USE": 0,
                  "NET_SETTLEMENT": 1,
                  "BALANCE_FOLDING": 2
                }
              },
              "NetZeroOffsetType": {
                "values": {
                  "NET_ZERO_OFFSET_TYPE_DO_NOT_USE": 0,
                  "SETTLED_LEDGER_ENTRY": 1,
                  "UNSETTLED_LEDGER_ENTRY": 2
                }
              }
            }
          },
          "ManualTransferDetail": {
            "fields": {
              "transferSpeed": {
                "type": ".squareup.ledger.ManualTransferDetail.TransferSpeed",
                "id": 1,
                "rule": "optional"
              },
              "instrumentToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "TransferSpeed": {
                "values": {
                  "TRANSFER_SPEED_DO_NOT_USE": 0,
                  "INSTANT": 1,
                  "NEXT_BUSINESS_DAY": 2
                }
              }
            }
          },
          "DeliveryReimbursementDetail": {
            "fields": {
              "squareOrderId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "deliveryOrderId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "MoneysweeperDetail": {
            "fields": {
              "isFromAllocation": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "isCaptureWithAppFee": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "captureLedgerEntryTokenForAppFee": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "didNotPersistClearedBalanceActivityReason": {
                "type": ".squareup.ledger.MoneysweeperDetail.DidNotPersistClearedBalanceActivityReason",
                "id": 5,
                "rule": "optional"
              }
            },
            "nested": {
              "DidNotPersistClearedBalanceActivityReason": {
                "values": {
                  "DID_NOT_PERSIST_CLEARED_BALANCE_ACTIVITY_REASON_DO_NOT_USE": 0,
                  "SETTLED_LEDGER_ENTRY": 1,
                  "LEDGER_ENTRY_AMOUNTS_NET_TO_ZERO": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.ledger?.nested?.LedgerEntryDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.UndoDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.RecoveryEventDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.AppFeeDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.PaymentFeeDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.FreeProcessingAdjustmentDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.MoneyTransferDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.MoneyTransferDetail?.nested?.ReversalDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.ThirdPartyFeeDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.ThirdPartyFeeDetail?.nested?.ThirdPartyTender && !$root.nested?.squareup?.nested?.ledger?.nested?.ThirdPartyFeeDetail?.nested?.ThirdPartyReversalTender && !$root.nested?.squareup?.nested?.ledger?.nested?.ThirdPartyFeeDetail?.nested?.ThirdPartyAppDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.PaymentDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.PaymentDetail?.nested?.Type && !$root.nested?.squareup?.nested?.ledger?.nested?.PaymentDetail?.nested?.CaptureSource && !$root.nested?.squareup?.nested?.ledger?.nested?.BookkeeperDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.FeeGroup && !$root.nested?.squareup?.nested?.ledger?.nested?.TaxGroup && !$root.nested?.squareup?.nested?.ledger?.nested?.NetZeroOffsetDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.NetZeroOffsetDetail?.nested?.NetZeroOffsetEvent && !$root.nested?.squareup?.nested?.ledger?.nested?.NetZeroOffsetDetail?.nested?.NetZeroOffsetType && !$root.nested?.squareup?.nested?.ledger?.nested?.ManualTransferDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.ManualTransferDetail?.nested?.TransferSpeed && !$root.nested?.squareup?.nested?.ledger?.nested?.DeliveryReimbursementDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.MoneysweeperDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.MoneysweeperDetail?.nested?.DidNotPersistClearedBalanceActivityReason) {
  $root.addJSON(jsonData);
}

/**
 * Metadata about a single ledger entry
 *
 * SOURCE LedgerEntryDetail @ squareup/ledger/detail.proto at 20:1
 */
export const LedgerEntryDetail = $root.lookupType('squareup.ledger.LedgerEntryDetail');
fixType(LedgerEntryDetail);
Builder.createAndAttachToType(LedgerEntryDetail);
/**
 * SOURCE UndoDetail @ squareup/ledger/detail.proto at 75:1
 */
export const UndoDetail = $root.lookupType('squareup.ledger.UndoDetail');
fixType(UndoDetail);
Builder.createAndAttachToType(UndoDetail);
/**
 * SOURCE RecoveryEventDetail @ squareup/ledger/detail.proto at 79:1
 */
export const RecoveryEventDetail = $root.lookupType('squareup.ledger.RecoveryEventDetail');
fixType(RecoveryEventDetail, {
  recoveryEventToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RecoveryEventDetail);
/**
 * SOURCE AppFeeDetail @ squareup/ledger/detail.proto at 84:1
 */
export const AppFeeDetail = $root.lookupType('squareup.ledger.AppFeeDetail');
fixType(AppFeeDetail, {
  paymentMerchantToken: {
    notEmpty: true
  },
  paymentToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(AppFeeDetail);
/**
 * SOURCE PaymentFeeDetail @ squareup/ledger/detail.proto at 96:1
 */
export const PaymentFeeDetail = $root.lookupType('squareup.ledger.PaymentFeeDetail');
fixType(PaymentFeeDetail, {
  principalLedgerEntryToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PaymentFeeDetail);
/**
 * SOURCE FreeProcessingAdjustmentDetail @ squareup/ledger/detail.proto at 118:1
 */
export const FreeProcessingAdjustmentDetail = $root.lookupType('squareup.ledger.FreeProcessingAdjustmentDetail');
fixType(FreeProcessingAdjustmentDetail);
Builder.createAndAttachToType(FreeProcessingAdjustmentDetail);
/**
 * SOURCE MoneyTransferDetail @ squareup/ledger/detail.proto at 129:1
 */
export const MoneyTransferDetail = $root.lookupType('squareup.ledger.MoneyTransferDetail');
fixType(MoneyTransferDetail);
Builder.createAndAttachToType(MoneyTransferDetail);
/**
 * SOURCE ReversalDetail @ squareup/ledger/detail.proto at 135:3
 */
MoneyTransferDetail.ReversalDetail = $root.lookupType('squareup.ledger.MoneyTransferDetail.ReversalDetail');
fixType(MoneyTransferDetail.ReversalDetail);
Builder.createAndAttachToType(MoneyTransferDetail.ReversalDetail);
/**
 * SOURCE ThirdPartyFeeDetail @ squareup/ledger/detail.proto at 147:1
 */
export const ThirdPartyFeeDetail = $root.lookupType('squareup.ledger.ThirdPartyFeeDetail');
fixType(ThirdPartyFeeDetail);
Builder.createAndAttachToType(ThirdPartyFeeDetail);
/**
 * Details about the Third Party Push Tender that created this fee
 *
 * SOURCE ThirdPartyTender @ squareup/ledger/detail.proto at 157:3
 */
ThirdPartyFeeDetail.ThirdPartyTender = $root.lookupType('squareup.ledger.ThirdPartyFeeDetail.ThirdPartyTender');
fixType(ThirdPartyFeeDetail.ThirdPartyTender);
Builder.createAndAttachToType(ThirdPartyFeeDetail.ThirdPartyTender);
/**
 * Details about the Third Party Reversal Tender that created this refunded fee
 *
 * SOURCE ThirdPartyReversalTender @ squareup/ledger/detail.proto at 166:3
 */
ThirdPartyFeeDetail.ThirdPartyReversalTender = $root.lookupType('squareup.ledger.ThirdPartyFeeDetail.ThirdPartyReversalTender');
fixType(ThirdPartyFeeDetail.ThirdPartyReversalTender);
Builder.createAndAttachToType(ThirdPartyFeeDetail.ThirdPartyReversalTender);
/**
 * Details about the developer application that charged the fee.
 * Only applicable to third party fees that are generated by an app_fee on capture.
 *
 * SOURCE ThirdPartyAppDetail @ squareup/ledger/detail.proto at 181:3
 */
ThirdPartyFeeDetail.ThirdPartyAppDetail = $root.lookupType('squareup.ledger.ThirdPartyFeeDetail.ThirdPartyAppDetail');
fixType(ThirdPartyFeeDetail.ThirdPartyAppDetail);
Builder.createAndAttachToType(ThirdPartyFeeDetail.ThirdPartyAppDetail);
/**
 * Metadata about a payment associated with a Ledger entry.
 *
 * This is a replacement of metadata encoded inside external sources so that
 * clients (e.g., Beemoreporter) no longer need to decode external source strings.
 *
 * TODO(kaneda): Backfill this once we fully finalize the design.
 *
 * Note that the payment token is not stored in this protocol message, but it can
 * be obtained from LedgerEntry.
 *
 * SOURCE PaymentDetail @ squareup/ledger/detail.proto at 203:1
 */
export const PaymentDetail = $root.lookupType('squareup.ledger.PaymentDetail');
fixType(PaymentDetail, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(PaymentDetail);
/**
 * Type of the payment.
 *
 * Note that this is not the type of the Ledger entry. For example, this is set to REFUND
 * when a FEE Ledger entry is created for the fee of a refund.
 *
 * SOURCE Type @ squareup/ledger/detail.proto at 210:3
 */
PaymentDetail.Type = $root.lookupEnum('squareup.ledger.PaymentDetail.Type').values;
/**
 * The source for this CAPTURE LE. Currently set for capture, refund, fee
 * and third-party-fee LEs. These will all reference the same capture_source
 * as the CAPTURE LE.
 *
 * SOURCE CaptureSource @ squareup/ledger/detail.proto at 233:3
 */
PaymentDetail.CaptureSource = $root.lookupEnum('squareup.ledger.PaymentDetail.CaptureSource').values;
/**
 * SOURCE BookkeeperDetail @ squareup/ledger/detail.proto at 284:1
 */
export const BookkeeperDetail = $root.lookupType('squareup.ledger.BookkeeperDetail');
fixType(BookkeeperDetail);
Builder.createAndAttachToType(BookkeeperDetail);
/**
 * A group of ledger entries related by a fee, and the metadata about that fee. Fee amounts are
 * currently inlined on ledger entries, so this is a group of one ledger entry.
 *
 * SOURCE FeeGroup @ squareup/ledger/detail.proto at 318:1
 */
export const FeeGroup = $root.lookupType('squareup.ledger.FeeGroup');
fixType(FeeGroup, {
  principalLedgerEntryToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(FeeGroup);
/**
 * A group of ledger entries related by a tax, and the metadata about that tax
 *
 * SOURCE TaxGroup @ squareup/ledger/detail.proto at 332:1
 */
export const TaxGroup = $root.lookupType('squareup.ledger.TaxGroup');
fixType(TaxGroup, {
  taxDetail: {
    required: true
  },
  principalLedgerEntryToken: {
    notEmpty: true
  },
  taxLedgerEntryToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TaxGroup);
/**
 * Detail belonging to a Ledger entry created as part of a net zero offset.
 *
 * SOURCE NetZeroOffsetDetail @ squareup/ledger/detail.proto at 352:1
 */
export const NetZeroOffsetDetail = $root.lookupType('squareup.ledger.NetZeroOffsetDetail');
fixType(NetZeroOffsetDetail, {
  type: {
    required: true
  },
  pairingOffsetLedgerEntryToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(NetZeroOffsetDetail);
/**
 * SOURCE NetZeroOffsetEvent @ squareup/ledger/detail.proto at 353:3
 */
NetZeroOffsetDetail.NetZeroOffsetEvent = $root.lookupEnum('squareup.ledger.NetZeroOffsetDetail.NetZeroOffsetEvent').values;
/**
 * SOURCE NetZeroOffsetType @ squareup/ledger/detail.proto at 367:3
 */
NetZeroOffsetDetail.NetZeroOffsetType = $root.lookupEnum('squareup.ledger.NetZeroOffsetDetail.NetZeroOffsetType').values;
/**
 * SOURCE ManualTransferDetail @ squareup/ledger/detail.proto at 409:1
 */
export const ManualTransferDetail = $root.lookupType('squareup.ledger.ManualTransferDetail');
fixType(ManualTransferDetail, {
  transferSpeed: {
    required: true
  }
});
Builder.createAndAttachToType(ManualTransferDetail);
/**
 * SOURCE TransferSpeed @ squareup/ledger/detail.proto at 410:3
 */
ManualTransferDetail.TransferSpeed = $root.lookupEnum('squareup.ledger.ManualTransferDetail.TransferSpeed').values;
/**
 * SOURCE DeliveryReimbursementDetail @ squareup/ledger/detail.proto at 426:1
 */
export const DeliveryReimbursementDetail = $root.lookupType('squareup.ledger.DeliveryReimbursementDetail');
fixType(DeliveryReimbursementDetail);
Builder.createAndAttachToType(DeliveryReimbursementDetail);
/**
 * SOURCE MoneysweeperDetail @ squareup/ledger/detail.proto at 434:1
 */
export const MoneysweeperDetail = $root.lookupType('squareup.ledger.MoneysweeperDetail');
fixType(MoneysweeperDetail);
Builder.createAndAttachToType(MoneysweeperDetail);
/**
 * The reason why we did not persist a ClearedBalanceActivity when creating this Ledger entry.
 *
 * SOURCE DidNotPersistClearedBalanceActivityReason @ squareup/ledger/detail.proto at 455:3
 */
MoneysweeperDetail.DidNotPersistClearedBalanceActivityReason = $root.lookupEnum('squareup.ledger.MoneysweeperDetail.DidNotPersistClearedBalanceActivityReason').values;